/**
 * @package store.dashboard.counters-data
 * @author Artem Ilinykh devsinglesly@gmail.com
 * @class CounterDataModule
 */
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import store from '@/store';
import { CounterData } from '@/modules/backend/Entities/CounterData';
import { FindCounterDataDto } from '@/modules/backend/CounterData/FindCounterDataDto';
import homeSmartApi from '@/plugins/HomeSmartApi';

@Module({ namespaced: true, store, name: 'dashboard/countersData' })
export class CounterDataModule extends VuexModule {
  private _items: Record<number, CounterData[]> = {};

  public get get(): (counterId: number) => CounterData[] {
    return (counterId: number): CounterData[] => (this._items[counterId] || []);
  }

  @Mutation
  private set(payload: CounterData[]): void {
    if (!payload.length) {
      return;
    }
    this._items = {
      ...this._items,
      [payload[0].getCounter().getId()]: payload
    };
  }

  @Mutation
  private removeDataItem(data: CounterData): void {
    this._items = {
      ...this._items,
      [data.getCounter().getId()]: this._items[data.getCounter().getId()]?.filter(i => i.getId() !== data.getId()) || []
    };
  }

  @Action({ rawError: true })
  public async fetch(params: FindCounterDataDto): Promise<void> {
    const data = await homeSmartApi.CountersData.fetch(params);
    this.context.commit('set', data);
  }

  @Action({ rawError: true })
  public async remove(data: CounterData): Promise<void> {
    await homeSmartApi.CountersData.remove(data.getId());
    this.context.commit('removeDataItem', data);
  }
}
